import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dadc670"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-custom-class": "body" }
const _hoisted_2 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_3 = {
  class: "MsoNormal",
  "data-custom-class": "title",
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { name: "_gm5sejt4p02f" }, null, -1))
const _hoisted_5 = { style: {"line-height":"150%","font-family":"Arial","font-size":"26px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("TERMS AND CONDITIONS")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  align: "center",
  style: {"text-align":"center","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("a", { name: "_7m5b3xg56u7y" })
], -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "subtitle",
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_9 = {
  class: "MsoNormal",
  "data-custom-class": "subtitle",
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_10 = { style: {"font-size":"11.0pt","line-height":"150%","font-family":"Arial","color":"#A6A6A6","mso-themecolor":"background1","mso-themeshade":"166"} }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(127, 127, 127)","font-size":"15px","text-align":"justify"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Last updated")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(127,127,127)","font-size":"14.6667px","text-align":"justify"} }, " ")
], -1))
const _hoisted_13 = { style: {"color":"rgb(127, 127, 127)","font-size":"15px","text-align":"justify"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "August 09, 2022", -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><strong data-v-5dadc670><span data-custom-class=\"heading_1\" data-v-5dadc670>TABLE OF CONTENTS</span></strong></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#agreement\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>1. AGREEMENT TO TERMS</span></span></a></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#ip\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>2. INTELLECTUAL PROPERTY RIGHTS</span></a></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#userreps\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>3. USER REPRESENTATIONS</span></a></div>", 8)
const _hoisted_23 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-custom-class": "link",
  href: "#userreg"
}, [
  /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "4. USER REGISTRATION")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("a", {
    "data-custom-class": "link",
    href: "#payment"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "5. FEES AND PAYMENT")
  ])
], -1))
const _hoisted_28 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("a", {
    "data-custom-class": "link",
    href: "#cancel"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "6. CANCELLATION")
  ])
], -1))
const _hoisted_31 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createStaticVNode("<div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#prohibited\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>7. PROHIBITED ACTIVITIES</span></a></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#ugc\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>8. USER GENERATED CONTRIBUTIONS</span></a></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#license\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>9. CONTRIBUTION LICENSE</span></a></div>", 3)
const _hoisted_36 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_38 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-custom-class": "link",
  href: "#mobile"
}, [
  /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "10. MOBILE APPLICATION LICENSE")
], -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_42 = { style: {"line-height":"1.5"} }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"1.5"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    "data-custom-class": "link",
    href: "#submissions"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "11. SUBMISSIONS")
  ])
], -1))
const _hoisted_45 = { style: {"line-height":"1.5"} }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_47 = { style: {"line-height":"1.5"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-custom-class": "link",
  href: "#advertisers"
}, [
  /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "12. ADVERTISERS")
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_51 = { style: {"line-height":"1.5"} }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-custom-class": "link",
  href: "#usrights"
}, [
  /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "13. U.S. GOVERNMENT RIGHTS")
], -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"line-height":"1.5"} }, [
  /*#__PURE__*/_createElementVNode("a", {
    "data-custom-class": "link",
    href: "#sitemanage"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "14. SITE MANAGEMENT")
  ])
], -1))
const _hoisted_56 = { style: {"line-height":"1.5"} }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-custom-class": "link",
  href: "#privacypolicy1"
}, [
  /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "15. PRIVACY POLICY")
], -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_61 = { style: {"line-height":"1.5"} }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_63 = { style: {"line-height":"1.5"} }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_65 = { "data-custom-class": "body_text" }
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#terms\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>16. TERM AND TERMINATION</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#modifications\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>17. MODIFICATIONS AND INTERRUPTIONS</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#law\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>18. GOVERNING LAW</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#disputes\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>19. DISPUTE RESOLUTION</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#corrections\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>20. CORRECTIONS</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#disclaimer\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>21. DISCLAIMER</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#liability\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>22. LIMITATIONS OF LIABILITY</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#indemnification\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>23. INDEMNIFICATION</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#userdata\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>24. USER DATA</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#electronic\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>25. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</span></a></div>", 10)
const _hoisted_76 = { style: {"line-height":"1.5"} }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-custom-class": "link",
  href: "#california"
}, [
  /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, "26. CALIFORNIA USERS AND RESIDENTS")
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "data-custom-class": "body_text" }, null, -1))
const _hoisted_80 = /*#__PURE__*/_createStaticVNode("<div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#misc\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>27. MISCELLANEOUS</span></a></div><div style=\"line-height:1.5;\" data-v-5dadc670><a data-custom-class=\"link\" href=\"#contact\" data-v-5dadc670><span data-custom-class=\"body_text\" data-v-5dadc670>28. CONTACT US</span></a></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" id=\"agreement\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_6aa3gkhykvst\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;font-size:19px;\" data-v-5dadc670>1. AGREEMENT TO TERMS</span></strong></div></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 6)
const _hoisted_86 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_87 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_88 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_89 = /*#__PURE__*/_createTextVNode("These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity (“you”) and ")
const _hoisted_90 = /*#__PURE__*/_createTextVNode("Akad Srl")
const _hoisted_91 = { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_92 = /*#__PURE__*/_createTextVNode(", doing business as ")
const _hoisted_93 = /*#__PURE__*/_createTextVNode("WP Darts")
const _hoisted_94 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_95 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_96 = /*#__PURE__*/_createTextVNode("(\"")
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "WP Darts", -1))
const _hoisted_98 = /*#__PURE__*/_createTextVNode("\", “")
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "we", -1))
const _hoisted_100 = /*#__PURE__*/_createTextVNode("”, “")
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "us", -1))
const _hoisted_102 = /*#__PURE__*/_createTextVNode("”, or “")
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "our", -1))
const _hoisted_104 = /*#__PURE__*/_createTextVNode("”), concerning your access to and use of the ")
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-custom-class": "link",
  href: "https://akad.it",
  target: "_blank"
}, "https://akad.it", -1))
const _hoisted_106 = /*#__PURE__*/_createTextVNode(" website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the “Site”).")
const _hoisted_107 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_108 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_109 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_110 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_111 = /*#__PURE__*/_createTextVNode(" We are registered in ")
const _hoisted_112 = /*#__PURE__*/_createTextVNode()
const _hoisted_113 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_114 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_115 = /*#__PURE__*/_createTextVNode("Italy")
const _hoisted_116 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_117 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_118 = /*#__PURE__*/_createTextVNode(" and have our registered office at ")
const _hoisted_119 = /*#__PURE__*/_createTextVNode("Via Str. Granda, 3, 33050 Perteole UD, Italy")
const _hoisted_120 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_121 = /*#__PURE__*/_createTextVNode("Ruda")
const _hoisted_122 = { style: {"font-size":"15px"} }
const _hoisted_123 = { "data-custom-class": "body_text" }
const _hoisted_124 = { style: {"font-size":"15px"} }
const _hoisted_125 = { "data-custom-class": "body_text" }
const _hoisted_126 = { style: {"color":"rgb(89, 89, 89)"} }
const _hoisted_127 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_128 = /*#__PURE__*/_createTextVNode("Friuli-Venezia Giulia")
const _hoisted_129 = /*#__PURE__*/_createTextVNode("33050")
const _hoisted_130 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_131 = { style: {"font-size":"11.0pt","line-height":"115%","mso-fareast-font-family":"Calibri","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_132 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_133 = /*#__PURE__*/_createTextVNode(" Our VAT number is ")
const _hoisted_134 = /*#__PURE__*/_createTextVNode("IT03037260308.")
const _hoisted_135 = /*#__PURE__*/_createTextVNode(" You agree that by accessing the Site, you have read, understood, and agree to be bound by all of these Terms of Use")
const _hoisted_136 = /*#__PURE__*/_createTextVNode(". IF YOU DO NOT AGREE WITH ALL OF THESE TERMS OF USE, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SITE AND YOU MUST DISCONTINUE USE IMMEDIATELY. ")
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_138 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_139 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_140 = { style: {"font-size":"15px"} }
const _hoisted_141 = { style: {"line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_142 = /*#__PURE__*/_createTextVNode("Supplemental terms and conditions or documents that may be posted on the Site from time to time are hereby expressly incorporated herein by reference. We reserve the right, in our sole discretion, to make changes or modifications to these Terms of Use ")
const _hoisted_143 = /*#__PURE__*/_createTextVNode("from time to time")
const _hoisted_144 = /*#__PURE__*/_createTextVNode(". We will alert you about any changes by updating the “Last updated” date of these Terms of Use, and you waive any right to receive specific notice of each such change. Please ensure that you check the applicable Terms every time you use our Site so that you understand which Terms apply. You will be subject to, and will be deemed to have been made aware of and to have accepted, the changes in any revised Terms of Use by your continued use of the Site after the date such revised Terms of Use are posted.")
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_146 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "The information provided on the Site is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose to access the Site from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.")
], -1))
const _hoisted_148 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_149 = { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_151 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_152 = { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_153 = /*#__PURE__*/_createTextVNode("The Site is not tailored to comply with industry-specific regulations (Health Insurance Portability and Accountability Act (HIPAA), Federal Information Security Management Act (FISMA), etc.), so if your interactions would be subjected to such laws, you may not use this Site. You may not use the Site in a way that would violate the Gramm-Leach-Bliley Act (GLBA).")
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_155 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_156 = { style: {"font-size":"15px"} }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }, "All users who are", -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"14.6667px"} }, " ", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }, "minors in the jurisdiction in which they reside (generally under the age of 18) must have the permission of, and be directly supervised by, their parent or guardian to use the Site. If you are a minor, you must have your parent or guardian read and agree to these Terms of Use prior to you using the Site.", -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_161 = /*#__PURE__*/_createStaticVNode("<div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"ip\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_b6y29mp52qvx\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;font-size:19px;\" data-v-5dadc670>2. INTELLECTUAL PROPERTY RIGHTS</span></strong></div></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;line-height:115%;font-family:Arial;color:rgb(89, 89, 89);\" data-v-5dadc670>Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the “Content”) and the trademarks, service marks, and logos contained therein (the “Marks”) are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws and various other intellectual property rights and unfair competition laws of the United States, international copyright laws, and international conventions. The Content and the Marks are provided on the Site “AS IS” for your information and personal use only. Except as expressly provided in these Terms of Use, no part of the Site and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.</span></div></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;line-height:115%;font-family:Arial;color:rgb(89, 89, 89);\" data-v-5dadc670>Provided that you are eligible to use the Site, you are granted a limited license to access and use the Site and to download or print a copy of any portion of the Content to which you have properly gained access solely for your personal, non-commercial use. We reserve all rights not expressly granted to you in and to the Site, the Content and the Marks.</span></div></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"userreps\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_5hg7kgyv9l8z\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;font-size:19px;\" data-v-5dadc670>3. USER REPRESENTATIONS</span></strong></div></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 9)
const _hoisted_170 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_171 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "By using the Site, you represent and warrant that:", -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"11pt"} }, " (", -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }, "1)", -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"11pt"} }, " ", -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }, "all registration information you submit will be true, accurate, current, and complete; (", -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)"} }, "2")
], -1))
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }, ") you will maintain the accuracy of such information and promptly update such registration information", -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"11pt"} }, " ", -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }, "as necessary;", -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_183 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }, "(", -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)"} }, "3")
], -1))
const _hoisted_186 = { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }
const _hoisted_187 = /*#__PURE__*/_createTextVNode(") you have the legal capacity and you agree to comply with these Terms of Use; ")
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }, "(", -1))
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(89, 89, 89)"} }, "4")
], -1))
const _hoisted_190 = { style: {"color":"rgb(89, 89, 89)","font-size":"15px"} }
const _hoisted_191 = /*#__PURE__*/_createTextVNode(") you are not a minor in the jurisdiction in which you reside")
const _hoisted_192 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_193 = /*#__PURE__*/_createTextVNode("or if a minor, you have received parental permission to use the Site")
const _hoisted_194 = /*#__PURE__*/_createTextVNode("; ")
const _hoisted_195 = /*#__PURE__*/_createStaticVNode("<span style=\"color:rgb(89, 89, 89);font-size:11pt;\" data-v-5dadc670> </span><span style=\"color:rgb(89, 89, 89);font-size:15px;\" data-v-5dadc670>(</span><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670>5</span></span><span style=\"color:rgb(89, 89, 89);font-size:15px;\" data-v-5dadc670>) you will not access the Site through automated or non-human means, whether through a bot, script or otherwise;</span><span style=\"color:rgb(89, 89, 89);font-size:11pt;\" data-v-5dadc670> </span><span style=\"color:rgb(89, 89, 89);font-size:15px;\" data-v-5dadc670>(</span><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670>6</span></span><span style=\"color:rgb(89, 89, 89);font-size:15px;\" data-v-5dadc670>) you will not use the Site for any illegal or unauthorized purpose; and (</span><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670>7</span></span><span style=\"color:rgb(89, 89, 89);font-size:15px;\" data-v-5dadc670>) your use of the Site will not violate any applicable law or regulation.</span>", 10)
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_206 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate your account and refuse any and all current or future use of the Site (or any portion thereof).")
], -1))
const _hoisted_208 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_209 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_210 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1"}
}
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "userreg",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5","text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "4. USER REGISTRATION")
  ])
], -1))
const _hoisted_212 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_213 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1"}
}
const _hoisted_214 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "You may be required to register with the Site. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.")
], -1))
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_217 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}
const _hoisted_218 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" id=\"payment\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_ynub0jdx8pob\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;font-size:19px;\" data-v-5dadc670>5. FEES AND PAYMENT</span></strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><span style=\"font-size:11.0pt;line-height:115%;font-family:Arial;color:#595959;mso-themecolor:text1;mso-themetint:166;\" data-v-5dadc670><br data-v-5dadc670></span></div><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);font-size:15px;\" data-v-5dadc670>We accept the following forms of payment:</span></div>", 3)
const _hoisted_221 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1"}
}
const _hoisted_222 = {
  class: "MsoNormal",
  style: {"line-height":"17.25px"}
}
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1","text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_224 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"margin-left":"46.9pt","text-indent":"-18.55pt","line-height":"1.5","text-align":"left"}
}
const _hoisted_225 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-indent":"-24.7333px"} }, "-  Visa", -1))
const _hoisted_227 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"margin-left":"46.9pt","text-indent":"-18.55pt","line-height":"1.5","text-align":"left"}
}
const _hoisted_228 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-indent":"-24.7333px"} }, "-  Mastercard", -1))
const _hoisted_230 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"margin-left":"46.9pt","text-indent":"-18.55pt","line-height":"1.5","text-align":"left"}
}
const _hoisted_231 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-indent":"-24.7333px"} }, "-  PayPal", -1))
const _hoisted_233 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"margin-left":"46.9pt","text-indent":"-18.55pt","line-height":"1.5","text-align":"left"}
}
const _hoisted_234 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-indent":"-24.7333px"} }, "-  American Express", -1))
const _hoisted_236 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"margin-left":"46.9pt","text-indent":"-18.55pt","line-height":"1.5","text-align":"left"}
}
const _hoisted_237 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"text-indent":"-24.7333px"} }, "-  Discover", -1))
const _hoisted_239 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"margin-left":"46.9pt","text-indent":"-18.55pt","line-height":"1.5","text-align":"left"}
}
const _hoisted_240 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "MsoNormal",
    style: {"line-height":"1","text-align":"left"}
  }, [
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_242 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_243 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5","text-align":"left"}
}
const _hoisted_244 = { style: {"line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_245 = /*#__PURE__*/_createTextVNode("You may be required to purchase or pay a fee to access some of our services. You agree to provide current, complete, and accurate purchase and account information for all purchases made via the Site. You further agree to promptly update account and payment information, including email address, payment method, and payment card expiration date, so that we can complete your transactions and contact you as needed. We bill you through an online billing account for purchases made via the Site. Sales tax will be added to the price of purchases as deemed required by us. We may change prices at any time. All payments shall be in ")
const _hoisted_246 = /*#__PURE__*/_createTextVNode("Euros")
const _hoisted_247 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_248 = { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1","text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_250 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5","text-align":"left"}
}
const _hoisted_251 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_252 = /*#__PURE__*/_createTextVNode("You agree to pay all charges or fees at the prices then in effect for your purchases, and you authorize us to charge your chosen payment provider for any such amounts upon making your purchase. ")
const _hoisted_253 = /*#__PURE__*/_createTextVNode("If ")
const _hoisted_254 = /*#__PURE__*/_createTextVNode("your purchase is subject to recurring charges, then you consent to our charging your payment method on a recurring basis without requiring your prior approval for each recurring charge, until you notify us of your cancellation.")
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "MsoNormal",
    "data-custom-class": "body_text",
    style: {"line-height":"1.5","text-align":"left"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","color":"rgb(89, 89, 89)"} }, "We reserve the right to correct any errors or mistakes in pricing, even if we have already requested or received payment. We also reserve the right to refuse any order placed through the Site.")
  ])
], -1))
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_259 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1"}
}
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5","text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("a", { name: "_drzjqilz2ujm" })
], -1))
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "cancel",
  "data-custom-class": "heading_1",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("a", { name: "_e993diqrk0qx" }),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "6. CANCELLATION")
  ])
], -1))
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_263 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}
const _hoisted_264 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5","text-align":"left"}
}
const _hoisted_265 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_266 = /*#__PURE__*/_createTextVNode("You can cancel your subscription at any time ")
const _hoisted_267 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }, " ", -1))
const _hoisted_268 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_269 = /*#__PURE__*/_createTextVNode("by contacting us using the contact")
const _hoisted_270 = { style: {"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_271 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_272 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_273 = /*#__PURE__*/_createTextVNode("information provided below")
const _hoisted_274 = /*#__PURE__*/_createTextVNode(". Your cancellation will take effect at the end of the current paid term. ")
const _hoisted_275 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_276 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1.5"}
}
const _hoisted_277 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5","text-align":"left"}
}
const _hoisted_278 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_279 = /*#__PURE__*/_createTextVNode("If you are unsatisfied with our services, please email us at ")
const _hoisted_280 = /*#__PURE__*/_createTextVNode("info@akad.it")
const _hoisted_281 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_282 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_284 = {
  class: "MsoNormal",
  style: {"line-height":"1"}
}
const _hoisted_285 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "prohibited",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5","text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("a", { name: "_h284p8mrs3r7" }),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "7. PROHIBITED ACTIVITIES")
  ])
], -1))
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_287 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "You may not access or use the Site for any purpose other than that for which we make the Site available. The Site may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.")
], -1))
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_289 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"115%"}
}
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5","text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }, "As a user of the Site, you agree not to:")
], -1))
const _hoisted_291 = /*#__PURE__*/_createStaticVNode("<li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:11pt;line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-size:15px;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Systematically retrieve data or other content from the Site to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.</span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Circumvent, disable, or otherwise interfere with security-related features of the Site, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Site and/or the Content contained therein.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Site.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Use any information obtained from the Site in order to harass, abuse, or harm another person.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Make improper use of our support services or submit false reports of abuse or misconduct.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Use the Site in a manner inconsistent with any applicable laws or regulations.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Engage in unauthorized framing of or linking to the Site.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Site or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Site.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Delete the copyright or other proprietary rights notice from any Content.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Attempt to impersonate another user or person or use the username of another user.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats (“gifs”), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as “spyware” or “passive collection mechanisms” or “pcms”).</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Interfere with, disrupt, or create an undue burden on the Site or the networks or services connected to the Site.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Site to you.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Attempt to bypass any measures of the Site designed to prevent or restrict access to the Site, or any portion of the Site.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Copy or adapt the Site’s software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Except as permitted by applicable law, decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Site.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Site, or using or launching any unauthorized script or other software.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Use a buying agent or purchasing agent to make purchases on the Site.</span></span></span></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Make any unauthorized use of the Site, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.</span></span></span></span></span></li>", 21)
const _hoisted_312 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5","text-align":"left"}
}
const _hoisted_313 = /*#__PURE__*/_createStaticVNode("<span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-family:sans-serif;font-style:normal;font-variant-ligatures:normal;font-variant-caps:normal;font-weight:400;letter-spacing:normal;orphans:2;text-align:justify;text-indent:-29.4px;text-transform:none;white-space:normal;widows:2;word-spacing:0px;-webkit-text-stroke-width:0px;background-color:rgb(255, 255, 255);text-decoration-style:initial;text-decoration-color:initial;color:rgb(89, 89, 89);\" data-v-5dadc670>Use the Site as part of any effort to compete with us or otherwise use the Site and/or the Content for any revenue-generating endeavor or commercial enterprise.</span></span></span></span></span>", 1)
const _hoisted_314 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_315 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5","text-align":"left"}
}
const _hoisted_316 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_317 = /*#__PURE__*/_createTextVNode("Sell or otherwise transfer your profile.")
const _hoisted_318 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("a", { name: "_zbbv9tgty199" })
], -1))
const _hoisted_320 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_321 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_322 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "ugc",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "8. USER GENERATED CONTRIBUTIONS")
  ])
], -1))
const _hoisted_324 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_325 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_326 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"115%"}
}
const _hoisted_327 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5","text-align":"left"}
}
const _hoisted_328 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_330 = /*#__PURE__*/_createTextVNode("The Site may invite you to chat, contribute to, or participate in blogs, message boards, online forums, and other functionality, and may provide you with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Site, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, \"Contributions\"). Contributions may be viewable by other users of the Site and through third-party websites. As such, any Contributions you transmit may be treated as non-confidential and non-proprietary. When you create or make available any Contributions, you thereby represent and warrant that:")
const _hoisted_331 = /*#__PURE__*/_createStaticVNode("<ul data-v-5dadc670><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>The creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your Contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.</span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>You are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the Site, and other users of the Site to use your Contributions in any manner contemplated by the Site and these Terms of Use.</span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>You have the written consent, release, and/or permission of each and every identifiable individual person in your Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of your Contributions in any manner contemplated by the Site and these Terms of Use.</span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions are not false, inaccurate, or misleading.</span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.</span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).</span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.</span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions are not used to harass or threaten (in the legal sense of those terms) any other person and to promote violence against a specific person or class of people.<br data-v-5dadc670></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions do not violate any applicable law, regulation, or rule.<br data-v-5dadc670></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions do not violate the privacy or publicity rights of any third party.<br data-v-5dadc670></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions do not violate any applicable law concerning child pornography, or otherwise intended to protect the health or well-being of minors.<br data-v-5dadc670></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.<br data-v-5dadc670></span></span></li><li class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"color:rgb(89, 89, 89);\" data-v-5dadc670><span style=\"font-size:14px;\" data-v-5dadc670>Your Contributions do not otherwise violate, or link to material that violates, any provision of these Terms of Use, or any applicable law or regulation.</span></span></li></ul><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;line-height:16.8667px;color:rgb(89, 89, 89);\" data-v-5dadc670>Any use of the Site in violation of the foregoing violates these Terms of Use and may result in, among other things, termination or suspension of your rights to use the Site.</span></div>", 2)
const _hoisted_333 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_334 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_335 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_336 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "license",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "9. CONTRIBUTION LICENSE")
  ])
], -1))
const _hoisted_337 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_338 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_339 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_340 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_341 = /*#__PURE__*/_createTextVNode("By posting your Contributions to any part of the Site")
const _hoisted_342 = /*#__PURE__*/_createTextVNode(", you automatically grant, and you represent and warrant that you have the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license to host, use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle, archive, store, cache, publicly perform, publicly display, reformat, translate, transmit, excerpt (in whole or in part), and distribute such Contributions (including, without limitation, your image and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative works of, or incorporate into other works, such Contributions, and grant and authorize sublicenses of the foregoing. The use and distribution may occur in any media formats and through any media channels. ")
const _hoisted_343 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_344 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_345 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "This license will apply to any form, media, or technology now known or hereafter developed, and includes our use of your name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names, logos, and personal and commercial images you provide. You waive all moral rights in your Contributions, and you warrant that moral rights have not otherwise been asserted in your Contributions. ")
  ])
], -1))
const _hoisted_346 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_347 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_348 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "We do not assert any ownership over your Contributions. You retain full ownership of all of your Contributions and any intellectual property rights or other proprietary rights associated with your Contributions. We are not liable for any statements or representations in your Contributions provided by you in any area on the Site. You are solely responsible for your Contributions to the Site and you expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding your Contributions.")
  ])
], -1))
const _hoisted_349 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_350 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_351 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "We have the right, in our sole and absolute discretion, (1) to edit, redact, or otherwise change any Contributions; (2) to re-categorize any Contributions to place them in more appropriate locations on the Site; and (3) to pre-screen or delete any Contributions at any time and for any reason, without notice. We have no obligation to monitor your Contributions.")
], -1))
const _hoisted_352 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_353 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_354 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_355 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "mobile",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "10. MOBILE APPLICATION LICENSE")
  ])
], -1))
const _hoisted_356 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_357 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_358 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "heading_2",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"15px"} }, "Use License")
  ])
], -1))
const _hoisted_359 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_360 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_361 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "If you access the Site via a mobile application, then we grant you a revocable, non-exclusive, non-transferable, limited right to install and use the mobile application on wireless electronic devices owned or controlled by you, and to access and use the mobile application on such devices strictly in accordance with the terms and conditions of this mobile application license contained in these Terms of Use. You shall not: (1) except as permitted by applicable law, decompile, reverse engineer, disassemble, attempt to derive the source code of, or decrypt the application; (2) make any modification, adaptation, improvement, enhancement, translation, or derivative work from the application; (3) violate any applicable laws, rules, or regulations in connection with your access or use of the application; (4) remove, alter, or obscure any proprietary notice (including any notice of copyright or trademark) posted by us or the licensors of the application; (5) use the application for any revenue generating endeavor, commercial enterprise, or other purpose for which it is not designed or intended; (6) make the application available over a network or other environment permitting access or use by multiple devices or users at the same time; (7) use the application for creating a product, service, or software that is, directly or indirectly, competitive with or in any way a substitute for the application; (8) use the application to send automated queries to any website or to send any unsolicited commercial e-mail; or (9) use any proprietary information or any of our interfaces or our other intellectual property in the design, development, manufacture, licensing, or distribution of any applications, accessories, or devices for use with the application.")
  ])
], -1))
const _hoisted_362 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_363 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_364 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "heading_2",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
    /*#__PURE__*/_createElementVNode("a", { name: "_vzf0b5xscg" }),
    /*#__PURE__*/_createElementVNode("strong", null, [
      /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial"} }, "Apple and Android Devices")
    ])
  ])
], -1))
const _hoisted_365 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_366 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_367 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "The following terms apply when you use a mobile application obtained from either the Apple Store or Google Play (each an “App Distributor”) to access the Site: (1) the license granted to you for our mobile application is limited to a non-transferable license to use the application on a device that utilizes the Apple iOS or Android operating systems, as applicable, and in accordance with the usage rules set forth in the applicable App Distributor’s terms of service; (2) we are responsible for providing any maintenance and support services with respect to the mobile application as specified in the terms and conditions of this mobile application license contained in these Terms of Use or as otherwise required under applicable law, and you acknowledge that each App Distributor has no obligation whatsoever to furnish any maintenance and support services with respect to the mobile application; (3) in the event of any failure of the mobile application to conform to any applicable warranty, you may notify the applicable App Distributor, and the App Distributor, in accordance with its terms and policies, may refund the purchase price, if any, paid for the mobile application, and to the maximum extent permitted by applicable law, the App Distributor will have no other warranty obligation whatsoever with respect to the mobile application; (4) you represent and warrant that (i) you are not located in a country that is subject to a U.S. government embargo, or that has been designated by the U.S. government as a “terrorist supporting” country and (ii) you are not listed on any U.S. government list of prohibited or restricted parties; (5) you must comply with applicable third-party terms of agreement when using the mobile application, e.g., if you have a VoIP application, then you must not be in violation of their wireless data service agreement when using the mobile application; and (6) you acknowledge and agree that the App Distributors are third-party beneficiaries of the terms and conditions in this mobile application license contained in these Terms of Use, and that each App Distributor will have the right (and will be deemed to have accepted the right) to enforce the terms and conditions in this mobile application license contained in these Terms of Use against you as a third-party beneficiary thereof.")
  ])
], -1))
const _hoisted_368 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_369 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_370 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_371 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_372 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "submissions",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("a", { name: "_wfq2hvrw11j4" }),
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "11. SUBMISSIONS")
  ])
], -1))
const _hoisted_373 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_374 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_375 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "You acknowledge and agree that any questions, comments, suggestions, ideas, feedback, or other information regarding the Site (\"Submissions\") provided by you to us are non-confidential and shall become our sole property. We shall own exclusive rights, including all intellectual property rights, and shall be entitled to the unrestricted use and dissemination of these Submissions for any lawful purpose, commercial or otherwise, without acknowledgment or compensation to you. You hereby waive all moral rights to any such Submissions, and you hereby warrant that any such Submissions are original with you or that you have the right to submit such Submissions. You agree there shall be no recourse against us for any alleged or actual infringement or misappropriation of any proprietary right in your Submissions.")
], -1))
const _hoisted_376 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_377 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_378 = {
  class: "MsoNormal",
  style: {"line-height":"1"}
}
const _hoisted_379 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "advertisers",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "12. ADVERTISERS")
  ])
], -1))
const _hoisted_380 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_381 = {
  class: "MsoNormal",
  style: {"line-height":"1"}
}
const _hoisted_382 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_383 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_384 = /*#__PURE__*/_createTextVNode("We allow advertisers to display their advertisements and other information in certain areas of the Site, such as sidebar advertisements or banner advertisements. If you are an advertiser, you shall take full responsibility for any advertisements you place on the Site and any services provided on the Site or products sold through those advertisements. Further, as an advertiser, you warrant and represent that you possess all rights and authority to place advertisements on the Site, including, but not limited to, intellectual property rights, publicity rights, and contractual rights. ")
const _hoisted_385 = /*#__PURE__*/_createTextVNode("We")
const _hoisted_386 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }, " ", -1))
const _hoisted_387 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }, "simply provide the space to place such advertisements, and we have no other relationship with advertisers.", -1))
const _hoisted_388 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_390 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_391 = { style: {"font-size":"15px"} }
const _hoisted_392 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"115%"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "MsoNormal",
    id: "usrights",
    "data-custom-class": "heading_1",
    style: {"text-align":"left","line-height":"1.5"}
  }, [
    /*#__PURE__*/_createElementVNode("strong", null, [
      /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "13. U.S. GOVERNMENT RIGHTS")
    ])
  ])
], -1))
const _hoisted_393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_394 = {
  class: "MsoNormal",
  style: {"text-align":"justify","line-height":"115%"}
}
const _hoisted_395 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><span style=\"font-size:15px;line-height:115%;font-family:Arial;color:rgb(89, 89, 89);background-image:initial;background-position:initial;background-size:initial;background-repeat:initial;background-attachment:initial;background-origin:initial;background-clip:initial;\" data-v-5dadc670>Our services are “commercial items” as defined in Federal Acquisition Regulation (“FAR”) 2.101. If our services are acquired by or on behalf of any agency not within the Department of Defense (“DOD”), our services are subject to the terms of these Terms of Use in accordance with FAR 12.212 (for computer software) and FAR 12.211 (for technical data). If our services are acquired by or on behalf of any agency within the Department of Defense, our services are subject to the terms of these Terms of Use in accordance with Defense Federal Acquisition Regulation (“DFARS”) 227.7202</span><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;color:rgb(89, 89, 89);background-image:initial;background-position:initial;background-size:initial;background-repeat:initial;background-attachment:initial;background-origin:initial;background-clip:initial;\" data-v-5dadc670>‑3. In addition, DFARS 252.227‑</span></span><span style=\"font-size:15px;line-height:115%;font-family:Arial;color:rgb(89, 89, 89);background-image:initial;background-position:initial;background-size:initial;background-repeat:initial;background-attachment:initial;background-origin:initial;background-clip:initial;\" data-v-5dadc670>7015 applies to technical data acquired by the DOD. This U.S. Government Rights clause is in lieu of, and supersedes, any other FAR, DFARS, or other clause or provision that addresses government rights in computer software or technical data under these Terms of Use.</span></div><div class=\"MsoNormal\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;text-align:left;\" data-v-5dadc670><br data-v-5dadc670></div>", 3)
const _hoisted_398 = {
  class: "MsoNormal",
  style: {"line-height":"1.5","text-align":"left"}
}
const _hoisted_399 = { style: {"font-size":"11.0pt","line-height":"115%","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_400 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_401 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" id=\"sitemanage\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_wj13r09u8u3u\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;font-size:19px;\" data-v-5dadc670>14. SITE MANAGEMENT</span></strong></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;line-height:115%;font-family:Arial;color:rgb(89, 89, 89);\" data-v-5dadc670>We reserve the right, but not the obligation, to: (1) monitor the Site for violations of these Terms of Use; (2) take appropriate legal action against anyone who, in our sole discretion, violates the law or these Terms of Use, including without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your Contributions or any portion thereof; (4) in our sole discretion and without limitation, notice, or liability, to remove from the Site or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; and (5) otherwise manage the Site in a manner designed to protect our rights and property and to facilitate the proper functioning of the Site.</span></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_jugvcvcw0oj9\" data-v-5dadc670></a></div></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div>", 5)
const _hoisted_406 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_407 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "privacypolicy1",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"line-height":"115%","font-family":"Arial","font-size":"19px"} }, "15. PRIVACY POLICY")
  ])
], -1))
const _hoisted_408 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_409 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_410 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_411 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_412 = /*#__PURE__*/_createTextVNode("We care about data privacy and security. Please review our Privacy Policy: ")
const _hoisted_413 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  "data-custom-class": "link",
  href: "https://akad.it/privacy-policy",
  target: "_blank"
}, "https://akad.it/privacy-policy", -1))
const _hoisted_414 = /*#__PURE__*/_createTextVNode(". By using the Site, you agree to be bound by our Privacy Policy, which is incorporated into these Terms of Use. Please be advised the Site is hosted in ")
const _hoisted_415 = /*#__PURE__*/_createTextVNode("Germany")
const _hoisted_416 = /*#__PURE__*/_createTextVNode(". If you access the Site from any other region of the world with laws or other requirements governing personal data collection, use, or disclosure that differ from applicable laws in ")
const _hoisted_417 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_418 = /*#__PURE__*/_createTextVNode("Germany")
const _hoisted_419 = /*#__PURE__*/_createTextVNode(", then through your continued use of the Site, ")
const _hoisted_420 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }, " ", -1))
const _hoisted_421 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_422 = /*#__PURE__*/_createTextVNode("you are transferring your data to ")
const _hoisted_423 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_424 = /*#__PURE__*/_createTextVNode("Germany")
const _hoisted_425 = /*#__PURE__*/_createTextVNode(", and you agree to have your data transferred to and processed in ")
const _hoisted_426 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_427 = /*#__PURE__*/_createTextVNode("Germany")
const _hoisted_428 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_429 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_430 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_431 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_432 = {
  align: "center",
  style: {"text-align":"left","line-height":"1"}
}
const _hoisted_433 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_434 = { style: {"font-size":"15px"} }
const _hoisted_435 = /*#__PURE__*/_createStaticVNode("<div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" id=\"terms\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_k3mndam4w6w1\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;font-size:19px;\" data-v-5dadc670>16. TERM AND TERMINATION</span></strong></div></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 2)
const _hoisted_437 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_438 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_439 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_440 = /*#__PURE__*/_createTextVNode("These Terms of Use shall remain in full force and effect while you use the Site. WITHOUT LIMITING ANY OTHER PROVISION OF THESE TERMS OF USE, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SITE (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE TERMS OF USE OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SITE OR DELETE ")
const _hoisted_441 = /*#__PURE__*/_createTextVNode("YOUR")
const _hoisted_442 = { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_443 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_444 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_445 = /*#__PURE__*/_createTextVNode("ACCOUNT AND ")
const _hoisted_446 = /*#__PURE__*/_createTextVNode("ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION. ")
const _hoisted_447 = /*#__PURE__*/_createStaticVNode("<div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;color:rgb(89, 89, 89);\" data-v-5dadc670>If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on behalf of the third party. In addition to terminating or suspending your account, we reserve the right to take appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.</span></span></div></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"modifications\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_e2dep1hfgltt\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;\" data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670>17. MODIFICATIONS AND INTERRUPTIONS</span></span></strong></div></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;line-height:115%;font-family:Arial;color:rgb(89, 89, 89);\" data-v-5dadc670>We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice. However, we have no obligation to update any information on our Site. We also reserve the right to modify or discontinue all or part of the Site without notice at any time. We will not be liable to you or any third party for any modification, price change, suspension, or discontinuance of the Site.</span></div></div><div align=\"center\" style=\"text-align:left;line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;line-height:115%;font-family:Arial;color:rgb(89, 89, 89);\" data-v-5dadc670>We cannot guarantee the Site will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Site, resulting in interruptions, delays, or errors. We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Site at any time or for any reason without notice to you. You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by your inability to access or use the Site during any downtime or discontinuance of the Site. Nothing in these Terms of Use will be construed to obligate us to maintain and support the Site or to supply any corrections, updates, or releases in connection therewith.</span></div></div><div align=\"center\" style=\"text-align:left;line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div>", 9)
const _hoisted_456 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_457 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"law\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_p6vbf8atcwhs\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;\" data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670>18. GOVERNING LAW</span></span></strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 3)
const _hoisted_460 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_461 = { style: {"font-size":"11.0pt","line-height":"115%","font-family":"Arial","color":"#595959","mso-themecolor":"text1","mso-themetint":"166"} }
const _hoisted_462 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_463 = { style: {"font-size":"15px"} }
const _hoisted_464 = /*#__PURE__*/_createTextVNode("These conditions are governed by and interpreted following the laws of ")
const _hoisted_465 = /*#__PURE__*/_createTextVNode("Italy")
const _hoisted_466 = /*#__PURE__*/_createTextVNode(", and the use of the United Nations Convention of Contracts for the International Sale of Goods is expressly excluded. If your habitual residence is in the EU, and you are a consumer, you additionally possess the protection provided to you by obligatory provisions of the law of your country of residence. ")
const _hoisted_467 = /*#__PURE__*/_createTextVNode("Akad Srl")
const _hoisted_468 = /*#__PURE__*/_createTextVNode(" and yourself both agree to submit to the non-exclusive jurisdiction of the courts of ")
const _hoisted_469 = /*#__PURE__*/_createTextVNode("__________")
const _hoisted_470 = /*#__PURE__*/_createTextVNode(", which means that you may make a claim to defend your consumer protection rights in regards to these Conditions of Use in ")
const _hoisted_471 = { style: {"font-size":"15px"} }
const _hoisted_472 = /*#__PURE__*/_createTextVNode("Italy")
const _hoisted_473 = /*#__PURE__*/_createTextVNode(", or in the EU country in which you reside.")
const _hoisted_474 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_475 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_476 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"disputes\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><a name=\"_v5i5tjw62cyw\" data-v-5dadc670></a><strong data-v-5dadc670><span style=\"line-height:115%;font-family:Arial;font-size:19px;\" data-v-5dadc670>19. DISPUTE RESOLUTION</span></strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 3)
const _hoisted_479 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_480 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_481 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_482 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_483 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "heading_2",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Informal Negotiations")
], -1))
const _hoisted_484 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_485 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_486 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_487 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, "To expedite r", -1))
const _hoisted_488 = { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }
const _hoisted_489 = /*#__PURE__*/_createTextVNode("esolution and control the cost of any dispute, controversy, or claim related to these Terms of Use (each \"Dispute\" and collectively, the “Disputes”) brought by either you or us (individually, a “Party” and collectively, the “Parties”), the Parties agree to first attempt to negotiate any Dispute (except those Disputes expressly provided below) informally for at least ")
const _hoisted_490 = /*#__PURE__*/_createTextVNode("__________")
const _hoisted_491 = /*#__PURE__*/_createTextVNode(" days before initiating arbitration. Such informal negotiations commence upon written notice from one Party to the other Party.")
const _hoisted_492 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_493 = {
  class: "MsoNormal",
  style: {"line-height":"1"}
}
const _hoisted_494 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}, null, -1))
const _hoisted_495 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  "data-custom-class": "heading_2",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px","line-height":"16.8667px","color":"rgb(89, 89, 89)"} }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Binding Arbitration")
  ])
], -1))
const _hoisted_496 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_497 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_498 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_499 = {
  align: "center",
  style: {"text-align":"left","line-height":"1.5"}
}
const _hoisted_500 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_501 = { style: {"font-size":"15px"} }
const _hoisted_502 = /*#__PURE__*/_createTextVNode("Any dispute arising from the relationships between the Parties to this contract shall be determined by one arbitrator who will be chosen in accordance with the Arbitration and Internal Rules of the European Court of Arbitration being part of the European Centre of Arbitration having its seat in Strasbourg, and which are in force at the time the application for arbitration is filed, and of which adoption of this clause constitutes acceptance. The seat of arbitration shall be ")
const _hoisted_503 = /*#__PURE__*/_createTextVNode("Italy")
const _hoisted_504 = /*#__PURE__*/_createTextVNode(". The language of the proceedings shall be ")
const _hoisted_505 = /*#__PURE__*/_createTextVNode("__________")
const _hoisted_506 = /*#__PURE__*/_createTextVNode(". Applicable rules of substantive law shall be the law of ")
const _hoisted_507 = /*#__PURE__*/_createTextVNode("Italy")
const _hoisted_508 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_509 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, null, -1))
const _hoisted_510 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" data-custom-class=\"heading_2\" style=\"line-height:1.5;\" data-v-5dadc670><strong data-v-5dadc670>Restrictions</strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670>The Parties agree that any arbitration shall be limited to the Dispute between the Parties individually. To the full extent permitted by law, (a) no arbitration shall be joined with any other proceeding; (b) there is no right or authority for any Dispute to be arbitrated on a class-action basis or to utilize class action procedures; and (c) there is no right or authority for any Dispute to be brought in a purported representative capacity on behalf of the general public or any other persons.</span></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 5)
const _hoisted_515 = {
  class: "MsoNormal",
  "data-custom-class": "heading_2",
  style: {"line-height":"1.5"}
}
const _hoisted_516 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, [
  /*#__PURE__*/_createElementVNode("strong")
], -1))
const _hoisted_517 = /*#__PURE__*/_createTextVNode("Exceptions to Informal Negotiations and Arbitration ")
const _hoisted_518 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, null, -1))
const _hoisted_519 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_520 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_521 = { style: {"font-size":"15px"} }
const _hoisted_522 = /*#__PURE__*/_createTextVNode("The Parties agree that the following Disputes are not subject to the above provisions concerning informal negotiations and binding arbitration: (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual property rights of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, or unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.")
const _hoisted_523 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_524 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_525 = { style: {"font-size":"15px"} }
const _hoisted_526 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_527 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_528 = { style: {"font-size":"15px"} }
const _hoisted_529 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_530 = { style: {"font-size":"15px","line-height":"115%","color":"rgb(89, 89, 89)"} }
const _hoisted_531 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"corrections\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><strong data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670>20. CORRECTIONS</span></strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670>There may be information on the Site that contains typographical errors, inaccuracies, or omissions, including descriptions, pricing, availability, and various other information. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Site at any time, without prior notice.</span></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"disclaimer\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><strong data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670>21. DISCLAIMER</span></strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670>THE SITE IS PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SITE AND OUR SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SITE AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SITE’S CONTENT OR THE CONTENT OF ANY WEBSITES LINKED TO THE SITE AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SITE, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SITE, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SITE BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SITE. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SITE, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.</span></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"liability\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><strong data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670>22. LIMITATIONS OF LIABILITY</span></strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 14)
const _hoisted_545 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_546 = { style: {"font-size":"15px"} }
const _hoisted_547 = /*#__PURE__*/_createTextVNode("IN ")
const _hoisted_548 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_549 = /*#__PURE__*/_createTextVNode("NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SITE, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. ")
const _hoisted_550 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_551 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"indemnification\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><strong data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670>23. INDEMNIFICATION</span></strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 4)
const _hoisted_555 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_556 = { style: {"font-size":"15px"} }
const _hoisted_557 = /*#__PURE__*/_createTextVNode("You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: ")
const _hoisted_558 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_559 = /*#__PURE__*/_createTextVNode("(1) your Contributions;")
const _hoisted_560 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_561 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_562 = /*#__PURE__*/_createTextVNode("(2) use of the Site; (3) breach of these Terms of Use; (4) any breach of your representations and warranties set forth in these Terms of Use; (5) your violation of the rights of a third party, including but not limited to intellectual property rights; or (6) any overt harmful act toward any other user of the Site with whom you connected via the Site. Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it. ")
const _hoisted_563 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"userdata\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><strong data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670>24. USER DATA</span></strong></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670>We will maintain certain data that you transmit to the Site for the purpose of managing the performance of the Site, as well as data relating to your use of the Site. Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the Site. You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.</span></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"electronic\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670><strong data-v-5dadc670>25. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES</strong></span></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670>Visiting <span style=\"line-height:115%;font-family:Arial;color:rgb(89, 89, 89);\" data-v-5dadc670>the Site, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Site, satisfy any legal requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SITE. You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means.</span></span></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div>", 12)
const _hoisted_575 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_576 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" id=\"california\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670><strong data-v-5dadc670>26. CALIFORNIA USERS AND RESIDENTS</strong></span></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670>If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.</span></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div>", 5)
const _hoisted_581 = {
  class: "MsoNormal",
  style: {"line-height":"1.5"}
}
const _hoisted_582 = { style: {"font-size":"15px"} }
const _hoisted_583 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  id: "misc",
  "data-custom-class": "heading_1",
  style: {"line-height":"1.5"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"19px"} }, "27. MISCELLANEOUS")
  ])
], -1))
const _hoisted_584 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "MsoNormal",
  style: {"line-height":"1"}
}, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_585 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_586 = { style: {"font-size":"15px"} }
const _hoisted_587 = /*#__PURE__*/_createTextVNode("These Terms of Use and any policies or operating rules posted by us on the Site or in respect to the Site constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Use shall not operate as a waiver of such right or provision. These Terms of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control. If any provision or part of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Terms of Use and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment or agency relationship created between you and us as a result of these Terms of Use or use of the Site. You agree that these Terms of Use will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Use and the lack of signing by the parties hereto to execute these Terms of Use.")
const _hoisted_588 = /*#__PURE__*/_createStaticVNode("<div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" style=\"line-height:1.5;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" id=\"contact\" data-custom-class=\"heading_1\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:19px;\" data-v-5dadc670><strong data-v-5dadc670>28. CONTACT US</strong></span></div><div class=\"MsoNormal\" style=\"line-height:1.1;\" data-v-5dadc670><br data-v-5dadc670></div><div class=\"MsoNormal\" data-custom-class=\"body_text\" style=\"line-height:1.5;\" data-v-5dadc670><span style=\"font-size:15px;\" data-v-5dadc670>In o<span style=\"font-size:15px;line-height:115%;font-family:Arial;color:rgb(89, 89, 89);\" data-v-5dadc670>rder to resolve a complaint regarding the Site or to receive further information regarding use of the Site, please contact us at:</span></span></div><div class=\"MsoNormal\" style=\"line-height:1;\" data-v-5dadc670><br data-v-5dadc670></div>", 6)
const _hoisted_594 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_595 = { style: {"font-size":"15px"} }
const _hoisted_596 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_597 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Akad Srl", -1))
const _hoisted_598 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_599 = { style: {"font-size":"15px"} }
const _hoisted_600 = { style: {"font-size":"15px","line-height":"115%","font-family":"Arial","color":"rgb(89, 89, 89)"} }
const _hoisted_601 = { style: {"color":"rgb(89, 89, 89)"} }
const _hoisted_602 = /*#__PURE__*/_createTextVNode("Via Str. Granda, 3, 33050 Perteole UD, Italy")
const _hoisted_603 = { style: {"color":"rgb(89, 89, 89)"} }
const _hoisted_604 = { style: {"font-size":"15px"} }
const _hoisted_605 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_606 = { style: {"color":"rgb(89, 89, 89)"} }
const _hoisted_607 = { style: {"font-size":"15px"} }
const _hoisted_608 = /*#__PURE__*/_createTextVNode("Ruda")
const _hoisted_609 = { style: {"color":"rgb(89, 89, 89)"} }
const _hoisted_610 = { style: {"font-size":"15px"} }
const _hoisted_611 = /*#__PURE__*/_createTextVNode(", ")
const _hoisted_612 = /*#__PURE__*/_createTextVNode("Friuli-Venezia Giulia")
const _hoisted_613 = { style: {"font-size":"15px"} }
const _hoisted_614 = { style: {"color":"rgb(89, 89, 89)"} }
const _hoisted_615 = /*#__PURE__*/_createTextVNode("33050")
const _hoisted_616 = { style: {"color":"rgb(89, 89, 89)"} }
const _hoisted_617 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_618 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} })
], -1))
const _hoisted_619 = /*#__PURE__*/_createTextVNode("Italy")
const _hoisted_620 = { style: {"font-size":"15px"} }
const _hoisted_621 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, null, -1))
const _hoisted_622 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, null, -1))
const _hoisted_623 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_624 = { style: {"font-size":"15px"} }
const _hoisted_625 = /*#__PURE__*/_createTextVNode("Phone: ")
const _hoisted_626 = /*#__PURE__*/_createTextVNode("__________")
const _hoisted_627 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_628 = { style: {"font-size":"15px"} }
const _hoisted_629 = {
  class: "MsoNormal",
  "data-custom-class": "body_text",
  style: {"line-height":"1.5"}
}
const _hoisted_630 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"15px"} }, "info@akad.it")
], -1))
const _hoisted_631 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#595959","font-size":"14px","font-family":"Arial","padding-top":"16px"} }, [
  /*#__PURE__*/_createTextVNode(" These terms of use were created using Termly's "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://termly.io/products/terms-and-conditions-generator/",
    style: {"color":"rgb(48, 48, 241) !important"}
  }, "Terms and Conditions Generator"),
  /*#__PURE__*/_createTextVNode(". ")
], -1))

export function render(_ctx, _cache) {
  const _component_bdt = _resolveComponent("bdt")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("strong", null, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_bdt, { class: "block-component" }),
              _createVNode(_component_bdt, { class: "question" }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
            ])
          ])
        ]),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_bdt, {
                class: "block-container question question-in-editor",
                "data-id": "0d5ae8ae-7749-9afb-1fed-6556cb563dc0",
                "data-type": "question"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_15,
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }),
        _hoisted_25,
        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
          default: _withCtx(() => [
            _hoisted_26
          ]),
          _: 1
        })
      ]),
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_29
          ]),
          _: 1
        })
      ]),
      _hoisted_30,
      _createElementVNode("div", _hoisted_31, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_32
          ]),
          _: 1
        })
      ]),
      _hoisted_33,
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_39
          ]),
          _: 1
        }),
        _hoisted_40,
        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
          default: _withCtx(() => [
            _hoisted_41
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_43
          ]),
          _: 1
        })
      ]),
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_46
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_47, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_48
          ]),
          _: 1
        }),
        _hoisted_49,
        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
          default: _withCtx(() => [
            _hoisted_50
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_51, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_52
          ]),
          _: 1
        }),
        _hoisted_53,
        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
          default: _withCtx(() => [
            _hoisted_54
          ]),
          _: 1
        })
      ]),
      _hoisted_55,
      _createElementVNode("div", _hoisted_56, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_57
          ]),
          _: 1
        }),
        _hoisted_58,
        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
          default: _withCtx(() => [
            _hoisted_59
          ]),
          _: 1
        }),
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_60
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_61, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_62
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_63, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_64
          ]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_65, [
          _createVNode(_component_bdt, { class: "block-component" }),
          _createVNode(_component_bdt, { class: "block-component" })
        ])
      ]),
      _hoisted_66,
      _createElementVNode("div", _hoisted_76, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_77
          ]),
          _: 1
        }),
        _hoisted_78,
        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
          default: _withCtx(() => [
            _hoisted_79
          ]),
          _: 1
        })
      ]),
      _hoisted_80,
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("span", _hoisted_88, [
            _hoisted_89,
            _createVNode(_component_bdt, {
              class: "block-container question question-in-editor",
              "data-id": "9d459c4e-c548-e5cb-7729-a118548965d2",
              "data-type": "question"
            }, {
              default: _withCtx(() => [
                _hoisted_90
              ]),
              _: 1
            })
          ]),
          _createElementVNode("span", _hoisted_91, [
            _createVNode(_component_bdt, { class: "block-component" }),
            _hoisted_92,
            _createVNode(_component_bdt, { class: "question" }, {
              default: _withCtx(() => [
                _hoisted_93
              ]),
              _: 1
            }),
            _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
            _hoisted_94
          ]),
          _createElementVNode("span", _hoisted_95, [
            _hoisted_96,
            _createVNode(_component_bdt, { class: "block-component" }),
            _createVNode(_component_bdt, { class: "question" }, {
              default: _withCtx(() => [
                _hoisted_97
              ]),
              _: 1
            }),
            _createVNode(_component_bdt, { class: "else-block" }),
            _hoisted_98,
            _hoisted_99,
            _hoisted_100,
            _hoisted_101,
            _hoisted_102,
            _hoisted_103,
            _hoisted_104,
            _createVNode(_component_bdt, {
              class: "block-container question question-in-editor",
              "data-id": "fdf30452-99b8-c68b-5cdf-34af764cd1fd",
              "data-type": "question"
            }, {
              default: _withCtx(() => [
                _hoisted_105
              ]),
              _: 1
            }),
            _hoisted_106,
            _createElementVNode("span", _hoisted_107, [
              _createElementVNode("span", _hoisted_108, [
                _createElementVNode("span", _hoisted_109, [
                  _createVNode(_component_bdt, { class: "question" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, { class: "block-component" })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("span", _hoisted_110, [
                    _createVNode(_component_bdt, { class: "block-component" })
                  ]),
                  _hoisted_111,
                  _createVNode(_component_bdt, { class: "block-component" }),
                  _createVNode(_component_bdt, { class: "block-component" }),
                  _hoisted_112,
                  _createElementVNode("span", _hoisted_113, [
                    _createElementVNode("span", _hoisted_114, [
                      _createVNode(_component_bdt, { class: "question" }, {
                        default: _withCtx(() => [
                          _hoisted_115
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_116, [
                            _createElementVNode("span", _hoisted_117, [
                              _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _hoisted_118,
                  _createVNode(_component_bdt, { class: "question" }, {
                    default: _withCtx(() => [
                      _hoisted_119
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_bdt, { class: "block-component" })
                ])
              ]),
              _hoisted_120,
              _createVNode(_component_bdt, { class: "question" }, {
                default: _withCtx(() => [
                  _hoisted_121
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("span", _hoisted_122, [
            _createElementVNode("span", _hoisted_123, [
              _createElementVNode("span", _hoisted_124, [
                _createElementVNode("span", _hoisted_125, [
                  _createElementVNode("span", _hoisted_126, [
                    _createVNode(_component_bdt, { class: "block-component" }),
                    _hoisted_127,
                    _createVNode(_component_bdt, { class: "question" }, {
                      default: _withCtx(() => [
                        _hoisted_128
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
                    _createVNode(_component_bdt, { class: "block-component" }),
                    _createVNode(_component_bdt, { class: "question" }, {
                      default: _withCtx(() => [
                        _hoisted_129
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("span", _hoisted_130, [
            _createElementVNode("span", _hoisted_131, [
              _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
                default: _withCtx(() => [
                  _hoisted_132
                ]),
                _: 1
              }),
              _createVNode(_component_bdt, { class: "else-block" })
            ])
          ]),
          _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
          _createVNode(_component_bdt, { class: "block-component" }),
          _hoisted_133,
          _createVNode(_component_bdt, { class: "question" }, {
            default: _withCtx(() => [
              _hoisted_134
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
          _hoisted_135,
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "c4a4c609-d962-97d8-9b96-d3492402adad",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, {
                    class: "block-component",
                    "data-record-question-key": "separate_agreement_option",
                    "data-type": "statement"
                  })
                ]),
                _: 1
              }),
              _hoisted_136
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_137,
      _createElementVNode("div", _hoisted_138, [
        _createElementVNode("div", _hoisted_139, [
          _createElementVNode("span", _hoisted_140, [
            _createElementVNode("span", _hoisted_141, [
              _hoisted_142,
              _createVNode(_component_bdt, { class: "block-component" }),
              _hoisted_143,
              _createVNode(_component_bdt, { class: "else-block" }),
              _hoisted_144
            ])
          ])
        ])
      ]),
      _hoisted_145,
      _createElementVNode("div", _hoisted_146, [
        _hoisted_147,
        _createElementVNode("div", _hoisted_148, [
          _createElementVNode("span", _hoisted_149, [
            _createVNode(_component_bdt, { class: "block-component" }),
            _createVNode(_component_bdt, { class: "block-component" })
          ])
        ]),
        _hoisted_150,
        _createElementVNode("div", _hoisted_151, [
          _createElementVNode("span", _hoisted_152, [
            _hoisted_153,
            _createVNode(_component_bdt, { class: "block-component" }),
            _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
          ])
        ]),
        _hoisted_154,
        _createElementVNode("div", _hoisted_155, [
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "a2595956-7028-dbe5-123e-d3d3a93ed076",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_156, [
                    _createVNode(_component_bdt, {
                      class: "block-component",
                      "data-record-question-key": "user_o18_option",
                      "data-type": "statement"
                    }),
                    _createVNode(_component_bdt, {
                      class: "block-container if",
                      id: "a2595956-7028-dbe5-123e-d3d3a93ed076",
                      "data-type": "if"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_bdt, { "data-type": "body" }, {
                              default: _withCtx(() => [
                                _hoisted_157,
                                _hoisted_158,
                                _hoisted_159
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, {
            class: "statement-end-if-in-editor",
            "data-type": "close"
          }, {
            default: _withCtx(() => [
              _hoisted_160
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_161,
      _createElementVNode("div", _hoisted_170, [
        _createElementVNode("div", _hoisted_171, [
          _hoisted_172,
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "d2d82ca8-275f-3f86-8149-8a5ef8054af6",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, {
                    class: "block-component",
                    "data-record-question-key": "user_account_option",
                    "data-type": "statement"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_173
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_bdt, { "data-type": "body" }, {
                    default: _withCtx(() => [
                      _hoisted_174,
                      _hoisted_175,
                      _hoisted_176,
                      _hoisted_177,
                      _hoisted_178,
                      _hoisted_179,
                      _hoisted_180,
                      _hoisted_181
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_bdt, {
                class: "statement-end-if-in-editor",
                "data-type": "close"
              }, {
                default: _withCtx(() => [
                  _hoisted_182
                ]),
                _: 1
              }),
              _hoisted_183
            ]),
            _: 1
          }),
          _hoisted_184,
          _hoisted_185,
          _createElementVNode("span", _hoisted_186, [
            _hoisted_187,
            _createVNode(_component_bdt, { class: "block-component" })
          ]),
          _hoisted_188,
          _hoisted_189,
          _createElementVNode("span", _hoisted_190, [
            _hoisted_191,
            _createVNode(_component_bdt, {
              class: "block-container if",
              id: "76948fab-ec9e-266a-bb91-948929c050c9",
              "data-type": "if"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "block-component",
                      "data-record-question-key": "user_o18_option",
                      "data-type": "statement"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_bdt, {
              class: "block-container if",
              id: "76948fab-ec9e-266a-bb91-948929c050c9",
              "data-type": "if"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "body" }, {
                      default: _withCtx(() => [
                        _hoisted_192
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_bdt, {
              class: "block-container if",
              id: "76948fab-ec9e-266a-bb91-948929c050c9",
              "data-type": "if"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "body" }, {
                      default: _withCtx(() => [
                        _hoisted_193
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_bdt, {
              class: "block-container if",
              id: "76948fab-ec9e-266a-bb91-948929c050c9",
              "data-type": "if"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, {
                  class: "statement-end-if-in-editor",
                  "data-type": "close"
                })
              ]),
              _: 1
            }),
            _hoisted_194
          ]),
          _hoisted_195
        ])
      ]),
      _hoisted_205,
      _createElementVNode("div", _hoisted_206, [
        _hoisted_207,
        _hoisted_208,
        _hoisted_209,
        _createElementVNode("div", _hoisted_210, [
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "d13abc62-cc6f-e059-7fd6-cb6208085aa7",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, {
                    class: "block-component",
                    "data-record-question-key": "user_account_option",
                    "data-type": "statement"
                  }),
                  _createVNode(_component_bdt, { "data-type": "body" }, {
                    default: _withCtx(() => [
                      _hoisted_211
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_212,
        _createElementVNode("div", _hoisted_213, [
          _createVNode(_component_bdt, {
            class: "block-container if",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "body" }, {
                    default: _withCtx(() => [
                      _hoisted_214
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_215,
        _hoisted_216,
        _createElementVNode("div", _hoisted_217, [
          _createVNode(_component_bdt, {
            class: "block-container if",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, {
                class: "statement-end-if-in-editor",
                "data-type": "close"
              })
            ]),
            _: 1
          })
        ]),
        _hoisted_218,
        _createElementVNode("div", _hoisted_221, [
          _createElementVNode("div", _hoisted_222, [
            _hoisted_223,
            _createElementVNode("div", _hoisted_224, [
              _createElementVNode("span", _hoisted_225, [
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  id: "a6e21b8e-b955-c546-15dd-bb6eda2fe88a",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, {
                          class: "forloop-component",
                          "data-record-question-key": "payment_list",
                          "data-type": "statement"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  id: "a6e21b8e-b955-c546-15dd-bb6eda2fe88a",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, { "data-type": "body" }, {
                          default: _withCtx(() => [
                            _hoisted_226
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_227, [
              _createElementVNode("span", _hoisted_228, [
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "for-end-in-editor",
                      "data-type": "close"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  id: "a6e21b8e-b955-c546-15dd-bb6eda2fe88a",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, { "data-type": "body" }, {
                          default: _withCtx(() => [
                            _hoisted_229
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_230, [
              _createElementVNode("span", _hoisted_231, [
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "for-end-in-editor",
                      "data-type": "close"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  id: "a6e21b8e-b955-c546-15dd-bb6eda2fe88a",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, { "data-type": "body" }, {
                          default: _withCtx(() => [
                            _hoisted_232
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_233, [
              _createElementVNode("span", _hoisted_234, [
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "for-end-in-editor",
                      "data-type": "close"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  id: "a6e21b8e-b955-c546-15dd-bb6eda2fe88a",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, { "data-type": "body" }, {
                          default: _withCtx(() => [
                            _hoisted_235
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_236, [
              _createElementVNode("span", _hoisted_237, [
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "for-end-in-editor",
                      "data-type": "close"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  id: "a6e21b8e-b955-c546-15dd-bb6eda2fe88a",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, { "data-type": "body" }, {
                          default: _withCtx(() => [
                            _hoisted_238
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_239, [
              _createElementVNode("span", _hoisted_240, [
                _createVNode(_component_bdt, {
                  class: "block-container forloop",
                  "data-type": "forloop"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "for-end-in-editor",
                      "data-type": "close"
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _hoisted_241,
          _createElementVNode("span", _hoisted_242, [
            _createElementVNode("div", _hoisted_243, [
              _createElementVNode("span", _hoisted_244, [
                _hoisted_245,
                _createVNode(_component_bdt, { class: "question" }, {
                  default: _withCtx(() => [
                    _hoisted_246
                  ]),
                  _: 1
                }),
                _hoisted_247
              ])
            ])
          ]),
          _createElementVNode("span", _hoisted_248, [
            _hoisted_249,
            _createElementVNode("div", _hoisted_250, [
              _createElementVNode("span", _hoisted_251, [
                _hoisted_252,
                _createVNode(_component_bdt, {
                  class: "block-container if",
                  id: "2955e4e9-b2fc-b1ce-6d2e-99ed4a0c390d",
                  "data-type": "if"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, {
                          class: "block-component",
                          "data-record-question-key": "recurring_charge_option",
                          "data-type": "statement"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, {
                  class: "block-container if",
                  id: "2955e4e9-b2fc-b1ce-6d2e-99ed4a0c390d",
                  "data-type": "if"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, { "data-type": "body" }, {
                          default: _withCtx(() => [
                            _hoisted_253
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, {
                  class: "block-container if",
                  id: "2955e4e9-b2fc-b1ce-6d2e-99ed4a0c390d",
                  "data-type": "if"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_bdt, { "data-type": "body" }, {
                          default: _withCtx(() => [
                            _hoisted_254
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, {
                  class: "block-container if",
                  id: "2955e4e9-b2fc-b1ce-6d2e-99ed4a0c390d",
                  "data-type": "if"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "statement-end-if-in-editor",
                      "data-type": "close"
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _hoisted_255
          ]),
          _hoisted_256
        ]),
        _hoisted_257,
        _hoisted_258,
        _createElementVNode("div", _hoisted_259, [
          _hoisted_260,
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "4380167d-5abe-b98f-f389-f707429e6c52",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, {
                    class: "block-component",
                    "data-record-question-key": "free_trial_option",
                    "data-type": "statement"
                  })
                ]),
                _: 1
              }),
              _hoisted_261
            ]),
            _: 1
          })
        ]),
        _hoisted_262,
        _createElementVNode("div", _hoisted_263, [
          _createElementVNode("div", _hoisted_264, [
            _createElementVNode("span", _hoisted_265, [
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "cef55cf6-3a65-8031-d0c3-cffe36e64f10",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, {
                        class: "block-component",
                        "data-record-question-key": "return_option",
                        "data-type": "statement"
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_266
                ]),
                _: 1
              })
            ]),
            _hoisted_267,
            _createElementVNode("span", _hoisted_268, [
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "1a40a488-252c-f087-02cc-5e0de451aa88",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, {
                        class: "block-component",
                        "data-record-question-key": "cancel_how",
                        "data-type": "statement"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "1a40a488-252c-f087-02cc-5e0de451aa88",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, { "data-type": "body" }, {
                        default: _withCtx(() => [
                          _hoisted_269
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("span", _hoisted_270, [
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "1a40a488-252c-f087-02cc-5e0de451aa88",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, { "data-type": "body" }, {
                        default: _withCtx(() => [
                          _hoisted_271
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createElementVNode("span", _hoisted_272, [
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "1a40a488-252c-f087-02cc-5e0de451aa88",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, { "data-type": "body" }, {
                        default: _withCtx(() => [
                          _hoisted_273
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "1a40a488-252c-f087-02cc-5e0de451aa88",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, {
                        class: "block-component",
                        "data-record-question-key": "cancel_how",
                        "data-type": "statement"
                      })
                    ]),
                    _: 1
                  }),
                  _hoisted_274
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_275,
        _createElementVNode("div", _hoisted_276, [
          _createElementVNode("div", _hoisted_277, [
            _createElementVNode("span", _hoisted_278, [
              _hoisted_279,
              _createVNode(_component_bdt, {
                class: "block-container question question-in-editor",
                "data-id": "7c40698b-5cc8-bb58-245d-2fbd1b57dfba",
                "data-type": "question"
              }, {
                default: _withCtx(() => [
                  _hoisted_280
                ]),
                _: 1
              }),
              _createVNode(_component_bdt, { class: "block-component" })
            ]),
            _hoisted_281
          ]),
          _hoisted_282,
          _hoisted_283,
          _createElementVNode("div", _hoisted_284, [
            _createVNode(_component_bdt, {
              class: "block-container if",
              id: "b671a946-ab46-9fff-9cee-e88149335e8e",
              "data-type": "if"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "block-component",
                      "data-record-question-key": "software_option",
                      "data-type": "statement"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _hoisted_285
        ]),
        _hoisted_286,
        _hoisted_287,
        _hoisted_288,
        _createElementVNode("div", _hoisted_289, [
          _hoisted_290,
          _createElementVNode("ul", null, [
            _hoisted_291,
            _createElementVNode("li", _hoisted_312, [
              _hoisted_313,
              _createElementVNode("span", _hoisted_314, [
                _createVNode(_component_bdt, { class: "forloop-component" })
              ])
            ]),
            _createElementVNode("li", _hoisted_315, [
              _createElementVNode("span", _hoisted_316, [
                _createVNode(_component_bdt, { class: "question" }, {
                  default: _withCtx(() => [
                    _hoisted_317
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("span", _hoisted_318, [
                _createVNode(_component_bdt, { class: "forloop-component" })
              ])
            ])
          ])
        ]),
        _hoisted_319
      ]),
      _hoisted_320,
      _hoisted_321,
      _createElementVNode("div", _hoisted_322, [
        _createVNode(_component_bdt, {
          class: "block-container if",
          "data-type": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "body" }, {
                  default: _withCtx(() => [
                    _hoisted_323
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _hoisted_324,
      _createElementVNode("div", _hoisted_325, [
        _createVNode(_component_bdt, {
          class: "block-container if",
          "data-type": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "body" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_326, [
                      _createElementVNode("div", _hoisted_327, [
                        _createElementVNode("span", _hoisted_328, [
                          _createVNode(_component_bdt, {
                            class: "block-container if",
                            id: "24327c5d-a34f-f7e7-88f1-65a2f788484f",
                            "data-type": "if"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_bdt, {
                                    class: "block-component",
                                    "data-record-question-key": "user_post_content_option",
                                    "data-type": "statement"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_329
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_330,
                          _createVNode(_component_bdt, { class: "else-block" })
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _hoisted_331
    ]),
    _hoisted_333,
    _hoisted_334,
    _createElementVNode("div", _hoisted_335, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_336
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_337,
    _createElementVNode("div", _hoisted_338, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_339, [
                    _createElementVNode("span", _hoisted_340, [
                      _createVNode(_component_bdt, {
                        class: "block-container if",
                        id: "a088ddfb-d8c1-9e58-6f21-958c3f4f0709",
                        "data-type": "if"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_bdt, {
                                class: "block-component",
                                "data-record-question-key": "user_post_content_option",
                                "data-type": "statement"
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_341,
                      _createVNode(_component_bdt, {
                        class: "block-container if",
                        id: "19652acc-9a2a-5ffe-6189-9474402fa6cc",
                        "data-type": "if"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_bdt, {
                                class: "block-component",
                                "data-record-question-key": "socialnetwork_link_option",
                                "data-type": "statement"
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_342
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_343,
    _createElementVNode("div", _hoisted_344, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_345
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_346,
    _createElementVNode("div", _hoisted_347, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_348
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_349,
    _createElementVNode("div", _hoisted_350, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_351
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_352,
    _hoisted_353,
    _createElementVNode("div", _hoisted_354, [
      _createVNode(_component_bdt, { class: "else-block" }),
      _createVNode(_component_bdt, {
        class: "block-container if",
        id: "a378120a-96b1-6fa3-279f-63d5b96341d3",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, {
                class: "block-component",
                "data-record-question-key": "review_option",
                "data-type": "statement"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "c954892f-02b9-c743-d1e8-faf0d59a4b70",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, {
                    class: "block-component",
                    "data-record-question-key": "mobile_app_option",
                    "data-type": "statement"
                  }),
                  _createVNode(_component_bdt, { "data-type": "body" }, {
                    default: _withCtx(() => [
                      _hoisted_355
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_356,
    _createElementVNode("div", _hoisted_357, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_358
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_359,
    _createElementVNode("div", _hoisted_360, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_361
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_362,
    _createElementVNode("div", _hoisted_363, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_364
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_365,
    _createElementVNode("div", _hoisted_366, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_367
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_368,
    _hoisted_369,
    _createElementVNode("div", _hoisted_370, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, {
            class: "statement-end-if-in-editor",
            "data-type": "close"
          }, {
            default: _withCtx(() => [
              _hoisted_371
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_bdt, {
        class: "block-container if",
        id: "e9981d4e-3a93-85dd-654b-7ecdf4bfe7d2",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, {
                class: "block-component",
                "data-record-question-key": "socialnetwork_link_option",
                "data-type": "statement"
              })
            ]),
            _: 1
          }),
          _hoisted_372
        ]),
        _: 1
      })
    ]),
    _hoisted_373,
    _createElementVNode("div", _hoisted_374, [
      _hoisted_375,
      _hoisted_376,
      _hoisted_377,
      _createElementVNode("div", _hoisted_378, [
        _createVNode(_component_bdt, {
          class: "block-container if",
          id: "36ce5a69-4560-4947-dc72-46e53e2d562a",
          "data-type": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, {
                  class: "block-component",
                  "data-record-question-key": "3rd_party_option",
                  "data-type": "statement"
                })
              ]),
              _: 1
            }),
            _createVNode(_component_bdt, {
              class: "block-container if",
              id: "14038561-dad7-be9d-370f-f8aa487b2570",
              "data-type": "if"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "block-component",
                      "data-record-question-key": "advertiser_option",
                      "data-type": "statement"
                    }),
                    _createVNode(_component_bdt, { "data-type": "body" }, {
                      default: _withCtx(() => [
                        _hoisted_379
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _hoisted_380,
      _createElementVNode("div", _hoisted_381, [
        _createVNode(_component_bdt, {
          class: "block-container if",
          "data-type": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "body" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_382, [
                      _createElementVNode("span", _hoisted_383, [
                        _hoisted_384,
                        _createVNode(_component_bdt, { class: "block-component" }),
                        _createVNode(_component_bdt, {
                          class: "block-container if",
                          id: "8ec10cc0-11fe-3699-b713-180daf1c979d",
                          "data-type": "if"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_bdt, {
                                  class: "block-component",
                                  "data-record-question-key": "copyright_agent_option",
                                  "data-type": "statement"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_bdt, {
          class: "block-container if",
          id: "8ec10cc0-11fe-3699-b713-180daf1c979d",
          "data-type": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_bdt, {
              class: "statement-end-if-in-editor",
              "data-type": "close"
            })
          ]),
          _: 1
        }),
        _hoisted_385,
        _hoisted_386,
        _hoisted_387
      ])
    ]),
    _hoisted_388,
    _hoisted_389,
    _createElementVNode("div", _hoisted_390, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, {
            class: "statement-end-if-in-editor",
            "data-type": "close"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_391, [
                _createVNode(_component_bdt, { class: "block-component" })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_392,
    _hoisted_393,
    _createElementVNode("div", _hoisted_394, [
      _hoisted_395,
      _createElementVNode("div", _hoisted_398, [
        _createElementVNode("span", _hoisted_399, [
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "14038561-dad7-be9d-370f-f8aa487b2570",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, {
                class: "statement-end-if-in-editor",
                "data-type": "close"
              }, {
                default: _withCtx(() => [
                  _hoisted_400
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _hoisted_401,
    _createElementVNode("div", _hoisted_406, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, {
                class: "block-component",
                "data-record-question-key": "privacy_policy_option",
                "data-type": "statement"
              }),
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_407
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_408,
    _createElementVNode("div", _hoisted_409, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_410, [
                    _createElementVNode("span", _hoisted_411, [
                      _hoisted_412,
                      _createElementVNode("strong", null, [
                        _createVNode(_component_bdt, {
                          class: "block-container question question-in-editor",
                          "data-id": "d10c7fd7-0685-12ac-c717-cbc45ff916d1",
                          "data-type": "question"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_413
                          ]),
                          _: 1
                        })
                      ]),
                      _hoisted_414,
                      _createVNode(_component_bdt, { class: "block-component" }),
                      _createVNode(_component_bdt, { class: "question" }, {
                        default: _withCtx(() => [
                          _hoisted_415
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
                      _hoisted_416,
                      _createElementVNode("span", _hoisted_417, [
                        _createVNode(_component_bdt, { class: "block-component" }),
                        _createVNode(_component_bdt, { class: "question" }, {
                          default: _withCtx(() => [
                            _hoisted_418
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                      ]),
                      _hoisted_419
                    ]),
                    _hoisted_420,
                    _createElementVNode("span", _hoisted_421, [
                      _hoisted_422,
                      _createElementVNode("span", _hoisted_423, [
                        _createVNode(_component_bdt, { class: "block-component" }),
                        _createVNode(_component_bdt, { class: "question" }, {
                          default: _withCtx(() => [
                            _hoisted_424
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                      ]),
                      _hoisted_425,
                      _createElementVNode("span", _hoisted_426, [
                        _createVNode(_component_bdt, { class: "block-component" }),
                        _createVNode(_component_bdt, { class: "question" }, {
                          default: _withCtx(() => [
                            _hoisted_427
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                      ]),
                      _hoisted_428,
                      _createVNode(_component_bdt, { class: "block-component" }),
                      _createVNode(_component_bdt, {
                        class: "block-container if",
                        id: "547bb7bb-ecf2-84b9-1cbb-a861dc3e14e7",
                        "data-type": "if"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_bdt, {
                                class: "block-component",
                                "data-record-question-key": "user_u13_option",
                                "data-type": "statement"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_429, [
                                    _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_430,
    _hoisted_431,
    _createElementVNode("div", _hoisted_432, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, {
            class: "statement-end-if-in-editor",
            "data-type": "close"
          }, {
            default: _withCtx(() => [
              _hoisted_433
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "7371467a-f2b5-2aff-cd0f-3379e970551e",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, {
                    class: "block-component",
                    "data-record-question-key": "privacy_policy_followup",
                    "data-type": "statement",
                    style: {"font-size":"14.6667px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, { class: "block-component" })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "923fc4bc-b171-82ba-b6eb-0a13c12d1b6b",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, {
                        class: "block-component",
                        "data-record-question-key": "copyright_agent_option",
                        "data-type": "statement"
                      }),
                      _createVNode(_component_bdt, {
                        class: "statement-end-if-in-editor",
                        "data-type": "close"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_434, [
                            _createVNode(_component_bdt, { class: "block-component" })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "95e88984-ac54-be9d-35de-f10fd010af14",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, {
                        class: "block-component",
                        "data-record-question-key": "no_agent_clause_option",
                        "data-type": "statement"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_bdt, { class: "block-component" })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_435,
    _createElementVNode("div", _hoisted_437, [
      _createElementVNode("div", _hoisted_438, [
        _createElementVNode("span", _hoisted_439, [
          _hoisted_440,
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "a6e121c2-36b4-5066-bf9f-a0a33512e768",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, {
                    class: "block-component",
                    "data-record-question-key": "user_account_option",
                    "data-type": "statement"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "a6e121c2-36b4-5066-bf9f-a0a33512e768",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "body" }, {
                    default: _withCtx(() => [
                      _hoisted_441
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_442, [
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "a6e121c2-36b4-5066-bf9f-a0a33512e768",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "body" }, {
                    default: _withCtx(() => [
                      _hoisted_443
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("span", _hoisted_444, [
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "a6e121c2-36b4-5066-bf9f-a0a33512e768",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "body" }, {
                    default: _withCtx(() => [
                      _hoisted_445
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, {
            class: "block-container if",
            id: "a6e121c2-36b4-5066-bf9f-a0a33512e768",
            "data-type": "if"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, {
                class: "statement-end-if-in-editor",
                "data-type": "close"
              })
            ]),
            _: 1
          }),
          _hoisted_446
        ])
      ])
    ]),
    _hoisted_447,
    _createElementVNode("div", _hoisted_456, [
      _hoisted_457,
      _createElementVNode("div", _hoisted_460, [
        _createElementVNode("span", _hoisted_461, [
          _createVNode(_component_bdt, { class: "block-component" })
        ])
      ]),
      _createElementVNode("div", _hoisted_462, [
        _createElementVNode("span", _hoisted_463, [
          _hoisted_464,
          _createVNode(_component_bdt, { class: "block-component" }),
          _createVNode(_component_bdt, { class: "question" }, {
            default: _withCtx(() => [
              _hoisted_465
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
          _hoisted_466,
          _createVNode(_component_bdt, { class: "question" }, {
            default: _withCtx(() => [
              _hoisted_467
            ]),
            _: 1
          }),
          _hoisted_468,
          _createVNode(_component_bdt, { class: "question" }, {
            default: _withCtx(() => [
              _hoisted_469
            ]),
            _: 1
          }),
          _hoisted_470,
          _createElementVNode("span", _hoisted_471, [
            _createVNode(_component_bdt, { class: "block-component" }),
            _createVNode(_component_bdt, { class: "question" }, {
              default: _withCtx(() => [
                _hoisted_472
              ]),
              _: 1
            }),
            _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
          ]),
          _hoisted_473,
          _createVNode(_component_bdt, { class: "else-block" })
        ])
      ])
    ]),
    _hoisted_474,
    _createElementVNode("div", _hoisted_475, [
      _hoisted_476,
      _createElementVNode("div", _hoisted_479, [
        _createVNode(_component_bdt, {
          class: "block-container if",
          "data-type": "if"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { class: "block-component" })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_480, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_481, [
                    _createVNode(_component_bdt, { class: "block-component" })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_482, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_483
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_484,
    _createElementVNode("div", _hoisted_485, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_486, [
                    _hoisted_487,
                    _createElementVNode("span", _hoisted_488, [
                      _hoisted_489,
                      _createVNode(_component_bdt, {
                        class: "block-container question question-in-editor",
                        "data-id": "33108d82-92fb-fbe9-6ef5-01cac7097351",
                        "data-type": "question"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_490
                        ]),
                        _: 1
                      }),
                      _hoisted_491
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_492,
    _createElementVNode("div", _hoisted_493, [
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_494
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_bdt, {
        class: "block-container if",
        "data-type": "if"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "body" }, {
                default: _withCtx(() => [
                  _hoisted_495
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_496,
    _createElementVNode("div", _hoisted_497, [
      _createVNode(_component_bdt, { class: "block-component" }, {
        default: _withCtx(() => [
          _hoisted_498
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_499, [
      _createElementVNode("div", _hoisted_500, [
        _createElementVNode("span", _hoisted_501, [
          _hoisted_502,
          _createVNode(_component_bdt, { class: "block-component" }),
          _createVNode(_component_bdt, { class: "block-component" }),
          _createVNode(_component_bdt, { class: "question" }, {
            default: _withCtx(() => [
              _hoisted_503
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
          _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
          _hoisted_504,
          _createVNode(_component_bdt, { class: "question" }, {
            default: _withCtx(() => [
              _hoisted_505
            ]),
            _: 1
          }),
          _hoisted_506,
          _createVNode(_component_bdt, { class: "block-component" }),
          _createVNode(_component_bdt, { class: "question" }, {
            default: _withCtx(() => [
              _hoisted_507
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }),
          _hoisted_508
        ]),
        _createVNode(_component_bdt, { class: "else-block" }, {
          default: _withCtx(() => [
            _hoisted_509
          ]),
          _: 1
        })
      ]),
      _hoisted_510,
      _createElementVNode("div", _hoisted_515, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_516
          ]),
          _: 1
        }),
        _hoisted_517,
        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
          default: _withCtx(() => [
            _hoisted_518
          ]),
          _: 1
        })
      ]),
      _hoisted_519,
      _createElementVNode("div", _hoisted_520, [
        _createElementVNode("span", _hoisted_521, [
          _createVNode(_component_bdt, { class: "block-component" }),
          _hoisted_522,
          _createElementVNode("span", _hoisted_523, [
            _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_524, [
        _createElementVNode("span", _hoisted_525, [
          _createElementVNode("span", _hoisted_526, [
            _createElementVNode("span", _hoisted_527, [
              _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_528, [
                    _createElementVNode("span", _hoisted_529, [
                      _createElementVNode("span", _hoisted_530, [
                        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                      ])
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_531,
      _createElementVNode("div", _hoisted_545, [
        _createElementVNode("span", _hoisted_546, [
          _hoisted_547,
          _createElementVNode("span", _hoisted_548, [
            _hoisted_549,
            _createElementVNode("span", _hoisted_550, [
              _createVNode(_component_bdt, {
                class: "block-container if",
                id: "3c3071ce-c603-4812-b8ca-ac40b91b9943",
                "data-type": "if"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_bdt, {
                        class: "block-component",
                        "data-record-question-key": "limitations_liability_option",
                        "data-type": "statement"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_551,
      _createElementVNode("div", _hoisted_555, [
        _createElementVNode("span", _hoisted_556, [
          _hoisted_557,
          _createElementVNode("span", _hoisted_558, [
            _createVNode(_component_bdt, {
              class: "block-container if",
              id: "475fffa5-05ca-def8-ac88-f426b238903c",
              "data-type": "if"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_bdt, {
                      class: "block-component",
                      "data-record-question-key": "user_post_content_option",
                      "data-type": "statement"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_bdt, { "data-type": "if" }, {
            default: _withCtx(() => [
              _createVNode(_component_bdt, { "data-type": "conditional-block" }, {
                default: _withCtx(() => [
                  _createVNode(_component_bdt, { "data-type": "body" }, {
                    default: _withCtx(() => [
                      _hoisted_559
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_bdt, { "data-type": "if" }, {
            default: _withCtx(() => [
              _hoisted_560
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_561, [
            _createVNode(_component_bdt, {
              class: "block-container if",
              id: "475fffa5-05ca-def8-ac88-f426b238903c",
              "data-type": "if"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_bdt, {
                  class: "statement-end-if-in-editor",
                  "data-type": "close"
                })
              ]),
              _: 1
            })
          ]),
          _hoisted_562
        ])
      ]),
      _hoisted_563,
      _createElementVNode("div", _hoisted_575, [
        _createVNode(_component_bdt, { class: "block-component" })
      ]),
      _hoisted_576,
      _createElementVNode("div", _hoisted_581, [
        _createElementVNode("span", _hoisted_582, [
          _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
        ])
      ]),
      _hoisted_583,
      _hoisted_584,
      _createElementVNode("div", _hoisted_585, [
        _createElementVNode("span", _hoisted_586, [
          _hoisted_587,
          _createVNode(_component_bdt, { class: "block-component" })
        ])
      ]),
      _hoisted_588,
      _createElementVNode("div", _hoisted_594, [
        _createElementVNode("span", _hoisted_595, [
          _createElementVNode("span", _hoisted_596, [
            _createVNode(_component_bdt, { class: "question" }, {
              default: _withCtx(() => [
                _hoisted_597
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_598, [
        _createElementVNode("span", _hoisted_599, [
          _createElementVNode("span", _hoisted_600, [
            _createElementVNode("strong", null, [
              _createElementVNode("span", _hoisted_601, [
                _createVNode(_component_bdt, { class: "question" }, {
                  default: _withCtx(() => [
                    _hoisted_602
                  ]),
                  _: 1
                }),
                _createElementVNode("strong", null, [
                  _createElementVNode("span", _hoisted_603, [
                    _createElementVNode("span", _hoisted_604, [
                      _createVNode(_component_bdt, { class: "block-component" })
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_605, [
        _createElementVNode("strong", null, [
          _createElementVNode("span", _hoisted_606, [
            _createElementVNode("span", _hoisted_607, [
              _createVNode(_component_bdt, { class: "question" }, {
                default: _withCtx(() => [
                  _hoisted_608
                ]),
                _: 1
              }),
              _createElementVNode("strong", null, [
                _createElementVNode("span", _hoisted_609, [
                  _createElementVNode("span", _hoisted_610, [
                    _createVNode(_component_bdt, { class: "block-component" }),
                    _hoisted_611,
                    _createVNode(_component_bdt, { class: "question" }, {
                      default: _withCtx(() => [
                        _hoisted_612
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                  ])
                ])
              ]),
              _createElementVNode("span", _hoisted_613, [
                _createElementVNode("strong", null, [
                  _createElementVNode("span", _hoisted_614, [
                    _createVNode(_component_bdt, { class: "block-component" }),
                    _createVNode(_component_bdt, { class: "question" }, {
                      default: _withCtx(() => [
                        _hoisted_615
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_bdt, { class: "statement-end-if-in-editor" })
                  ])
                ]),
                _createElementVNode("strong", null, [
                  _createElementVNode("span", _hoisted_616, [
                    _createVNode(_component_bdt, { class: "block-component" }),
                    _createVNode(_component_bdt, { class: "block-component" })
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_617, [
        _createVNode(_component_bdt, { class: "block-component" }, {
          default: _withCtx(() => [
            _hoisted_618
          ]),
          _: 1
        }),
        _createVNode(_component_bdt, { class: "question" }, {
          default: _withCtx(() => [
            _hoisted_619
          ]),
          _: 1
        }),
        _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
          default: _withCtx(() => [
            _createElementVNode("strong", null, [
              _createElementVNode("span", _hoisted_620, [
                _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
                  default: _withCtx(() => [
                    _hoisted_621
                  ]),
                  _: 1
                }),
                _createVNode(_component_bdt, { class: "statement-end-if-in-editor" }, {
                  default: _withCtx(() => [
                    _hoisted_622
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_623, [
        _createElementVNode("strong", null, [
          _createElementVNode("span", _hoisted_624, [
            _hoisted_625,
            _createVNode(_component_bdt, { class: "question" }, {
              default: _withCtx(() => [
                _hoisted_626
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_627, [
        _createElementVNode("strong", null, [
          _createElementVNode("span", _hoisted_628, [
            _createVNode(_component_bdt, { class: "block-component" })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_629, [
        _createVNode(_component_bdt, { class: "question" }, {
          default: _withCtx(() => [
            _hoisted_630
          ]),
          _: 1
        })
      ])
    ]),
    _hoisted_631
  ], 64))
}